<script lang="tsx">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ScreenView",
  render() {
    return (
      <div class="allContent">
        <router-view></router-view>
      </div>
    );
  },
});
</script>
<style scoped lang="sass">
.allContent {
  width: 100%;
  height: 100%;
  background: #EFF3FF;
}
</style>
